<div class="flex flex-col gap-1 w-full animate-fade-in p-4">
  <app-header
    title="User Management"
    searchPlaceholder="Search username, email..."
    [showNew]="false"
    [showFilter]="false"
    (onSearch)="handleSearch($event)"
  ></app-header>

  <app-table
    [allData]="tableData"
    [columns]="tableColumns"
    [actions]="tableActions"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    (onLazyLoad)="loadUsersLazy($event)"
  >
  </app-table>
</div>
